import React from "react";
import ReactDOM from "react-dom";
import Button from "@material-ui/core/Button";
import Manage from "../../manage/manage";

const BANNER_HEIGHT = 56;

export const ManagePreviewOverlay = ({ user, onClose }) => {
  if (!user) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999999,
        backgroundColor: "#1c1c1c",
      }}
    >
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: BANNER_HEIGHT,
          boxSizing: "border-box",
          zIndex: 1000000,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#b8860b",
          color: "white",
          padding: "0 20px",
          fontWeight: "bold",
        }}
      >
        <span>
          ÖNİZLEME MODU — {user.name} olarak Yönetim sayfasını
          görüntülüyorsunuz. Bu kişi adına hiçbir işlem (ödeme, feragat vb.)
          gerçekleştirilmez.
        </span>
        <Button variant="contained" color="secondary" onClick={onClose}>
          Önizlemeden Çık
        </Button>
      </div>
      <div
        style={{
          position: "absolute",
          top: BANNER_HEIGHT,
          left: 0,
          right: 0,
          bottom: 0,
          overflowY: "auto",
        }}
      >
        <Manage previewUser={user} />
      </div>
    </div>,
    document.body,
  );
};

export default ManagePreviewOverlay;
